import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f18a850"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f18a850')) {
      api.createRecord('1f18a850', component.options)
    } else {
      api.reload('1f18a850', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f18a850", function () {
      api.rerender('1f18a850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/index.vue"
export default component.exports